/**
 * Main application layout component
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import './MainLayout.css';

/**
 * Main layout wrapper with header, sidebar, and content area
 * @returns {React.ReactElement} Layout element
 */
export default function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="layout">
      <Header onMenuToggle={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
      <main className="layout__main">
        <div className="layout__content">
          <Outlet />
        </div>
      </main>
      <MobileNav />
    </div>
  );
}
